
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    open: Boolean,
    type: [String, Number],
    size: String,
    options: Array,
    onSelect: Function,
    selected: [Number, String],
  },
  setup() {
    return {};
  },
});
